import { DEFAULT_MAX_ITEMS_PER_SLIDE } from "./constants.js";
import useCheckScreen from "../../../hooks/useCheckScreen/index.js";
function useResponsiveItemsPerSlide(itemsPerSlide = DEFAULT_MAX_ITEMS_PER_SLIDE) {
  const { isMobile, isDesktop, isTablet } = useCheckScreen();
  let currItemsPerSlide = typeof itemsPerSlide === "number" ? itemsPerSlide : itemsPerSlide.mobile;
  if (typeof itemsPerSlide !== "number") {
    isMobile && (currItemsPerSlide = itemsPerSlide.mobile);
    isTablet && (currItemsPerSlide = itemsPerSlide.tablet);
    isDesktop && (currItemsPerSlide = itemsPerSlide.desktop);
  }
  if (currItemsPerSlide < 1) {
    console.error("Invalid itemsPerSlide found, falling back to default.");
    return [DEFAULT_MAX_ITEMS_PER_SLIDE.mobile];
  }
  return [currItemsPerSlide];
}
export {
  useResponsiveItemsPerSlide
};
